import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { useFlags } from "launchdarkly-react-client-sdk";
import { isSilentObserverAvailable } from "../../shared/function";
import useLanguageChange from "../../hooks/useLanguageChange";
import { callEndWithMediate } from "../SilentObserver/SilentObserverUtils";

const MediateButton = () => {
    const { isRemoteParticipantJoined } = useSelector((state) => state.commonReducer);
    const localisedValues = useLanguageChange();
    const ldFlags = useFlags();

    /*  - The "Mediate" option is removed from the Silent Observer user if LD is On for the domain.
        - Flag name = hide-mediate-button
        - Default LD Flag = OFF
    */
    const isMediateButtonAvailable = useMemo(() => !ldFlags.hideMediateButton, [ldFlags]);

    return (
        <>
            {isSilentObserverAvailable() && isMediateButtonAvailable && (
                <div className='action-button' data-testid='mediate-button-component'>
                    <div className='action-button-in custom-tooltip top-tooltip center-tooltip tooltip-auto-width'>
                        <button
                            className='call-action-btn'
                            disabled={!isRemoteParticipantJoined}
                            onClick={() => callEndWithMediate("confirmMediate")}
                            data-testid='mediate-btn'
                        >
                            <span className='action-button-icon'>
                                <span className='for-icon icon-mediate'></span>
                            </span>
                            <span className='for-text'>{localisedValues?.mediate_lable}</span>
                        </button>
                        {isRemoteParticipantJoined && (
                            <div className='custom-tooltip-content text-nowrap'>
                                <div className='custom-tooltip-in'>
                                    <p>{localisedValues["join_call_as_participant"]}</p>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            )}
        </>
    );
};

export default MediateButton;
